import { ImgBackgroundWrapper } from 'components/Common/CommonWrappers';
import { txtAnimation } from 'components/Home/BannerItems';
import { BodyTextM, SubtitleM, GRAY30 } from 'global-styles';
import Image from 'next/image';
import { memo } from 'react';
import { useInView } from 'react-intersection-observer';
import styled, { css } from 'styled-components';
import { ProductCommonTitleEn, ProductCommonTitleKR } from './ProductCommons';
import { LocaleObj } from './ProductFeatures';

interface Props {
  locale: string;
  devicesPlatforms: {
    platform: LocaleObj;
    device: LocaleObj;
    bgImg: string;
    pictogram: string;
  }[];
  devicesPlatformsDesc?: { ko: string; en: string };
}

const ProductDevicesPlatforms = ({
  locale,
  devicesPlatforms,
  devicesPlatformsDesc,
}: Props) => {
  const [targetRef, isVisible] = useInView({ fallbackInView: true });

  return (
    <ProductDevicesPlatformsContainer ref={targetRef} isVisible={isVisible}>
      <div className="feat-title-wrapper">
        <div>
          {locale === 'en' ? (
            <ProductCommonTitleEn>
              Supported Devices / Supported Platforms
            </ProductCommonTitleEn>
          ) : (
            <ProductCommonTitleKR>
              지원 디바이스 / 지원 플랫폼
            </ProductCommonTitleKR>
          )}
        </div>
      </div>
      {devicesPlatformsDesc && (
        <SubtitleM className="d-p-desc">
          {devicesPlatformsDesc[locale]}
        </SubtitleM>
      )}
      <div className="img-wrapper">
        {devicesPlatforms.map(devicePlatform => (
          <div className="left-wrapper" key={devicePlatform.bgImg}>
            <ImgBackgroundWrapper style={{ backgroundColor: '#253a50' }}>
              <Image
                sizes="(min-width: 905px) 40vw,
                  (min-width: 600px) 80vw,
                  (max-width: 599px) 48vw
                  "
                src={devicePlatform.bgImg}
                layout="fill"
                alt="About bluedot"
                className="target-img"
                objectFit="cover"
                quality={60}
                priority
              />
            </ImgBackgroundWrapper>
            <div className="picto-wrapper">
              <Image
                sizes="160px"
                src={devicePlatform.pictogram}
                layout="fill"
                alt="About bluedot"
                objectFit="cover"
                quality={70}
                priority
                className="d-p-i"
              />
            </div>
            <SubtitleM className="d-p-t">
              {devicePlatform.platform[locale]}
            </SubtitleM>
            <BodyTextM className="d-p-t">
              {devicePlatform.device[locale]}
            </BodyTextM>
          </div>
        ))}
      </div>
    </ProductDevicesPlatformsContainer>
  );
};
export default memo(ProductDevicesPlatforms);

const ProductDevicesPlatformsContainer = styled.article<{ isVisible: boolean }>`
  padding: 96px 0 146px;
  .feat-title-wrapper > div {
    opacity: 0;
  }
  .d-p-t,
  .d-p-i {
    opacity: 0;
  }
  .img-wrapper {
    width: 100%;
    display: flex;
  }
  .left-wrapper {
    position: relative;
    width: 50%;
    height: 328px;
    overflow: hidden;
    color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .d-p-desc {
    margin-bottom: 32px;
    color: ${GRAY30};
  }
  .picto-wrapper {
    position: relative;
    width: 160px;
    height: 160px;
    margin-bottom: 8px;
  }
  ${({ isVisible }) =>
    isVisible &&
    css`
      .feat-title-wrapper {
        overflow-y: hidden;
      }
      .feat-title-wrapper > div {
        animation: ${txtAnimation} 1s cubic-bezier(0.4, 0, 0.2, 1) backwards;
        opacity: 1;
      }
      .d-p-i {
        animation: ${txtAnimation} 1s 0.6s cubic-bezier(0.4, 0, 0.2, 1)
          backwards;
        opacity: 1;
      }
      .d-p-t {
        animation: ${txtAnimation} 1s 0.9s cubic-bezier(0.4, 0, 0.2, 1)
          backwards;
        opacity: 1;
      }
    `};
  @media screen and (max-width: 904px) {
    padding: 56px 0 96px;
    .img-wrapper {
      flex-direction: column;
    }
    .left-wrapper {
      width: 100%;
    }
  }
  @media screen and (max-width: 599px) {
    padding: 32px 0 56px;
    .left-wrapper {
      height: 280px;
    }
  }
`;
